import React, { Context } from "react";
import { AppContext, AppContextInterface } from "../app-context-provider";
import { PageItem } from "./component-switcher";
import SectionTitle from "./section-title";

export interface TextComponentProps {
    item: PageItem;
    textContent: string;
    mainTitle: string;
}

export interface TextComponentState {}

class TextComponent extends React.Component<
    TextComponentProps,
    TextComponentState
> {
    static contextType: Context<AppContextInterface | null> = AppContext;
    public context!: AppContextInterface;
    state: TextComponentState = {};

    // constructor(props: TextComponentProps) {
    //     super(props);
    // }

    render() {
        return (
            <div className="standard-component">
                <SectionTitle title={this.props.mainTitle} />
                <div
                    className="text-content"
                    dangerouslySetInnerHTML={{ __html: this.props.textContent }}
                />
            </div>
        );
    }
}

export default TextComponent;
